import { AuthProvider } from "./state/AuthContext";
import { AppShell } from "./components/AppShell";

export function App() {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
}
